import { render, staticRenderFns } from "./LpuCardsPlaceDrawer.vue?vue&type=template&id=498f2c48&scoped=true&"
import script from "./LpuCardsPlaceDrawer.vue?vue&type=script&setup=true&lang=ts&"
export * from "./LpuCardsPlaceDrawer.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./LpuCardsPlaceDrawer.vue?vue&type=style&index=0&id=498f2c48&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "498f2c48",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('498f2c48')) {
      api.createRecord('498f2c48', component.options)
    } else {
      api.reload('498f2c48', component.options)
    }
    module.hot.accept("./LpuCardsPlaceDrawer.vue?vue&type=template&id=498f2c48&scoped=true&", function () {
      api.rerender('498f2c48', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/[town-translit]/diagnostika/analiz/components/LpuCard/LpuCardsPlaceDrawer.vue"
export default component.exports